/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "sbuatwyiqtzloxzljnfa"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNidWF0d3lpcXR6bG94emxqbmZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIyODE5NTUsImV4cCI6MjA3Nzg1Nzk1NX0.KAqSLzTx7-8kbGvaAdygfL6Gp0BPVoLrz8WN_pqhKw4"